/**
 * Offline-authored airport assets. The source manifest records the official
 * AIP movement geometry separately from its OSM-derived architectural layer.
 */
export const VILNIUS_AIRPORT_MANIFEST_URL =
  "/assets/airport/manifest.json";

export const VILNIUS_AIRPORT_AIRFIELD_ID =
  "vilnius-airport-airfield";

/**
 * Airfield surfaces sit only centimetres above the shared terrain so the
 * avatar remains visually grounded. A small render-only depth bias keeps
 * those coplanar overlays stable at flight-camera distances.
 */
export const VILNIUS_AIRPORT_SURFACE_MATERIAL_NAMES: ReadonlySet<string> =
  new Set([
    "apron",
    "runway",
    "taxiway",
    "marking_white",
    "marking_yellow",
  ]);
export const VILNIUS_AIRPORT_SURFACE_POLYGON_OFFSET_FACTOR = -1;
export const VILNIUS_AIRPORT_SURFACE_POLYGON_OFFSET_UNITS_BY_MATERIAL:
  Readonly<Record<string, number>> = Object.freeze({
    apron: -1,
    runway: -2,
    taxiway: -3,
    marking_white: -4,
    marking_yellow: -4,
  });

export const VILNIUS_AIRPORT_ASSET_COUNT = 3;
export const VILNIUS_AIRPORT_AIRCRAFT_COUNT = 3;
